import { render, staticRenderFns } from "./promotionPreference.vue?vue&type=template&id=2cf7ba64&"
import script from "./promotionPreference.vue?vue&type=script&lang=js&"
export * from "./promotionPreference.vue?vue&type=script&lang=js&"
import style0 from "./promotionPreference.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports